export var getDateTimeMask = function getDateTimeMask(val) {
  var digits = (val.match(/\d+/g) || []).join('');
  var dayStart = digits.slice(0, 2).padEnd(2, 'D');
  var monthStart = digits.slice(2, 4).padEnd(2, 'M');
  var yearStart = digits.slice(4, 8).padEnd(4, 'Y');
  var dayEnd = digits.slice(8, 10).padEnd(2, 'D');
  var monthEnd = digits.slice(10, 12).padEnd(2, 'M');
  var yearEnd = digits.slice(12, 16).padEnd(4, 'Y');
  return "".concat(dayStart, ".").concat(monthStart, ".").concat(yearStart, " - ").concat(dayEnd, ".").concat(monthEnd, ".").concat(yearEnd);
};